import { Box, ButtonBase, Card, CardContent, CardMedia, Dialog, DialogContent, Grid, Typography, useMediaQuery } from "@mui/material";
import HaveAccount from "../../../icons/HaveAccount.svg";
import CreateAccount from "../../../icons/CreateAccount.svg";
import CheckOutGuest from "../../../icons/CheckOutGuest.svg";
import WhiteInosio from "../../../icons/whiteinosio.svg";

interface PayMethodModalProps {
    open: boolean;
    onTileClickIHaveAnAccount: () => void;
    onTileClickCheckoutAsGuest: () => void;
    onTileClickCreateAnAccount: () => void;
}
const PaymentMethodModal = (props: PayMethodModalProps) => {
    const isOnMobileScreen = useMediaQuery("(max-width:600px)");
    const style = {
        height: isOnMobileScreen ? "100%" : "523px",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    };
    return (
        <Dialog
            open={props.open}
            fullScreen={isOnMobileScreen}
            BackdropProps={{
                invisible: true,
            }}
            fullWidth={true}
            disableEnforceFocus
            style={{
                background: "none",
            }}
            PaperProps={{
                style: {
                    pointerEvents: "auto",
                    borderRadius: isOnMobileScreen ? "0px" : "24px",
                    width: isOnMobileScreen ? "100%" : "472px",
                    boxShadow: "none",
                    overflow: "hidden"
                },
            }}
            disableEscapeKeyDown={true}
        >
            <DialogContent>
                <Box sx={style}>
                    <Grid item display="flex" flexDirection="column" alignItems='center'>
                        {isOnMobileScreen ?
                            <Grid item display='flex' justifyContent='center' ml={6} sx={{ width: '340px', position: 'relative', top: '10%' }}>
                                <img src={WhiteInosio} style={{ width: "75px", height: "75px" }} alt="logo" />
                                <Typography
                                    sx={{
                                        fontFamily: "Work Sans",
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        fontSize: '18px',
                                        lineHeight: '23px',
                                        color: '#14142B',
                                        textAlign: 'left',
                                        padding: '15px'
                                    }}>
                                    Rohan's Property Management Company
                                </Typography>
                            </Grid> :
                            <Typography sx={{
                                fontFamily: "Work Sans",
                                fontStyle: 'normal',
                                fontWeight: 700,
                                fontSize: '18px',
                                lineHeight: '23px',
                                color: '#14142B',
                            }}>
                                How do you want to pay
                            </Typography>}
                        <Card id='cardId' sx={{
                            padding: '0',
                            width: 340,
                            boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
                            borderRadius: '20px',
                            marginTop: '30px !important',
                        }}>
                            <ButtonBase
                                id='buttonBase'
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'start',
                                    width: '100%',
                                    padding: '15px 0 15px 18px',
                                    textAlign: 'initial',
                                }}
                                onClick={() => { props.onTileClickIHaveAnAccount() }}
                            >
                                <CardMedia
                                    id='cardMedia'
                                    component="img"
                                    sx={{ width: 48, marginRight: '30px' }}
                                    image={HaveAccount}
                                    alt="HaveAccount"
                                />
                                <CardContent>

                                    <Typography id='haveAccount' sx={{

                                        fontFamily: "Work Sans",
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        fontSize: '18px',
                                        lineHeight: '23px',
                                        color: '#14142B',
                                    }}>
                                        I Have an Account
                                    </Typography>
                                </CardContent>
                            </ButtonBase>
                        </Card>
                        <Card sx={{
                            padding: '0',
                            width: 340,
                            boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
                            borderRadius: '20px',
                            marginTop: '30px !important',
                        }}>
                            <ButtonBase
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'start',
                                    width: '100%',
                                    padding: '15px 0 15px 18px',
                                    textAlign: 'initial',
                                }}
                                onClick={() => { props.onTileClickCreateAnAccount() }}
                            >
                                <CardMedia
                                    component="img"
                                    sx={{ width: 48, marginRight: '28px' }}
                                    image={CreateAccount}
                                    alt="HaveAccount"
                                />
                                <CardContent>
                                    <Typography sx={{
                                        fontFamily: "Work Sans",
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        fontSize: '18px',
                                        lineHeight: '23px',
                                        color: '#14142B',
                                    }}>
                                        Create an Account
                                    </Typography>
                                </CardContent>
                            </ButtonBase>
                        </Card>
                        <Card sx={{
                            padding: '0',
                            width: 340,
                            boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
                            borderRadius: '20px',
                            marginTop: '30px !important',
                        }}>
                            <ButtonBase
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'start',
                                    width: '100%',
                                    padding: '15px 0 15px 18px',
                                    textAlign: 'initial',
                                }}
                                onClick={() => { props.onTileClickCheckoutAsGuest() }}
                            >
                                <CardMedia
                                    component="img"
                                    sx={{ width: 58, marginRight: '20px' }}
                                    image={CheckOutGuest}
                                    alt="HaveAccount"
                                />
                                <CardContent>
                                    <Typography id='checkOutAsGuests' sx={{
                                        fontFamily: "Work Sans",
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        fontSize: '18px',
                                        lineHeight: '23px',
                                        color: '#14142B',
                                    }}>
                                        Checkout as Guest
                                    </Typography>
                                </CardContent>
                            </ButtonBase>
                        </Card>
                    </Grid>
                </Box>
            </DialogContent>
        </Dialog>
    );
}

export default PaymentMethodModal;
